import appConfig from '@/common/appConfig';
import { setPersonProperties, getDistinctId } from '@/common/store/pinia/telemetry/core/client';
import type { RoleInfo } from '@/common/store/pinia/telemetry/core/types';

type UserLike = {
  id?: string;
  domain_id?: string;
  project_id?: string;
  roles?: Array<{ id?: string }>;
  is_superuser?: boolean;
  external_provider?: string;
};

export const updateUser = (
  user: UserLike | null | undefined,
  roleInfo: RoleInfo,
  additionalProps: Record<string, unknown> = {}
): void => {
  try {
    const distinctId = getDistinctId();

    if (user?.id) {
      let displayName = `project_member_${distinctId}`;

      if (roleInfo.isSystemAdmin) {
        displayName = `admin_${distinctId}`;
      } else if (roleInfo.isDomainAdmin) {
        displayName = `domain_admin_${distinctId}`;
      }

      setPersonProperties({
        vz_app_env: appConfig.app_env,
        vz_initially_logged_in: true,
        vz_domain_id: user.domain_id,
        vz_project_id: user.project_id,
        vz_roles: user.roles?.map(role => role.id),
        vz_is_superuser: user.is_superuser,
        vz_external_provider: user.external_provider,
        vz_display_name: displayName,
        ...additionalProps
      });
    } else {
      setPersonProperties({
        vz_app_env: appConfig.app_env,
        vz_initially_logged_in: false,
        vz_display_name: `not_authenticated_${distinctId}`,
        ...additionalProps
      });
    }
  } catch (err) {
    // Silently continue without telemetry metadata
  }
};

export const registerVersionData = (versionInfo: {
  frontendVersion: string;
  productVersion?: string;
  productRelease?: string;
  storageName?: string;
}): void => {
  setPersonProperties({
    vz_frontend_version: versionInfo.frontendVersion,
    vz_product_version: versionInfo.productVersion,
    vz_product_release: versionInfo.productRelease,
    vz_storage_name: versionInfo.storageName
  });
};
